import Http from "../services/Http";

export default function Companies() {
    function get() {
        return Http.get(`/companies/`);
    }

    return { get };
}
